import { Grid, Paper } from "@mui/material";
import { styled } from "@mui/material/styles";

export const MonthPaper = styled(Paper)({
  width: 290,
});

export const WeekGrid = styled(Grid)(({ theme }) => ({
  marginTop: theme.spacing(1),
  paddingLeft: theme.spacing(3),
  paddingRight: theme.spacing(3),
}));

export const DayGrid = styled(Grid)(({ theme }) => ({
  paddingLeft: theme.spacing(2),
  paddingRight: theme.spacing(2),
  marginTop: theme.spacing(2),
  marginBottom: theme.spacing(3),
}));
